<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Update Settings" @show="setUpdateData" @hide="cancelModal()">
    <b-row>
      <b-col sm="12">
        <p-input v-model="form.value" :label="updateData.label" name="value" :handler="$v" :helptext="updateData.Comment" :formData="form" type="text" />
      </b-col>
      <b-col sm="12">
        <b-button variant="success" @click="update()" :disabled="requesting">Update</b-button>
        <b-button variant="outline-danger" @click="cancelModal()">Cancel</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required } from 'vuelidate/lib/validators'
import { PInput } from '../../../components'

export default {
  name: 'Update-Settings',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      requesting: false,
      form: {
        key: '',
        value: '',
        errorMessages: {
          key: {
            required: 'Key is required'
          },
          value: {
            required: 'Value is required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      key: { required },
      value: { required }
    }
  },
  components: {
    PInput
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    }
  },
  methods: {
    setUpdateData () {
      this.form.key = this.updateData.Parameter
      this.form.value = this.updateData.Value
    },
    async update () {
      try {
        this.requesting = true
        await this.$http.post(this.API_ENDPOINT + '/lottery/settings/update', {
          key: this.form.key,
          value: this.form.value
        }, {
          headers: { 'Content-Type': 'application/json' }
        })
        this.cancelModal()
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Config Updated Successfully.')
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.requesting = false
      }
    },
    cancelModal () {
      this.form.key = ''
      this.form.value = ''
      this.$v.form.$reset()
      this.$emit('closeModal')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/lottery/settings/Update.vue